<template>
  <div
    class="disclaimer-main cursor-pointer"
    :class="{
      stylized1: stylized === '0',
      stylized2: stylized === '1'
    }"
    @click="more"
  >
    <div
      class="content"
      :class="{
        ellipsis: !index
      }"
      v-html="content"
    ></div>
    <i v-if="content" :class="['icon', 'el-icon-arrow-up', { lmethod: !index }]"></i>
  </div>
</template>

<script>
export default {
  name: 'DisclaimerContent',
  props: {
    content: {
      type: String,
      default: ''
    },
    stylized: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      index: 0
    }
  },
  methods: {
    more(ev) {
      this.index = Number(!this.index)
      ev.stopPropagation()
    }
  }
}
</script>

<style lang="scss">
.disclaimer-main {
  position: relative;

  &.stylized1 {
    .ellipsis {
      position: relative;
      box-sizing: border-box;
      height: 18px;
      padding-right: 18px;
      overflow: hidden;

      &::after {
        position: absolute;
        top: 0;
        right: 20px !important;
        display: inline-block;
        width: 18px;
        content: '...';
      }
    }

    .icon {
      position: absolute;
      top: 3px;
      right: 0;
      color: theme('colors.text.secondary');
      cursor: pointer;
      transition: all 0.2s ease;

      &.lmethod {
        transform: rotate(180deg);
      }
    }
  }

  &.stylized2 {
    .icon {
      display: none;
    }
  }

  .content {
    * {
      font-family: theme('fontFamily.pingFang');
      font-size: theme('fontSize.small');
      font-weight: 400;
      line-height: 18px;
      color: theme('colors.text.secondary');
      text-align: justify;
    }

    p {
      font-size: theme('fontSize.small');
      color: theme('colors.text.third');
    }
  }
}
</style>
